import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { isTrackingEnabled, readConsent, saveConsent, updateConsent } from "../../analytics";
import Styles from "./CookieBanner.styles";

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [answered, setAnswered] = useState(() => readConsent() !== null);

  // Nothing to ask while tracking is switched off (no GTM id), or once the visitor has answered
  if (!isTrackingEnabled() || answered) return null;

  const choose = (choice: "granted" | "denied") => {
    saveConsent(choice);
    updateConsent(choice);
    setAnswered(true);
  };

  return (
    <Styles.Banner role="dialog" aria-label={t("CookieBannerTitle")}>
      <Styles.Text>
        <Styles.Title>{t("CookieBannerTitle")}</Styles.Title>
        <Styles.Description>
          {t("CookieBannerText")}
          <Link to="/privacy-policy">{t("CookieBannerPolicy")}</Link>
        </Styles.Description>
      </Styles.Text>
      <Styles.Actions>
        <Styles.DeclineBtn onClick={() => choose("denied")}>{t("CookieDecline")}</Styles.DeclineBtn>
        <Styles.AcceptBtn onClick={() => choose("granted")}>{t("CookieAccept")}</Styles.AcceptBtn>
      </Styles.Actions>
    </Styles.Banner>
  );
};
